import { apiRequest, buildQuery } from "@/apis/client";
import type {
  CreateUserPayload,
  UpdateUserPayload,
  UserItem,
  UsersListResponse,
} from "@/apis/types";

export interface ListUsersParams {
  page?: number;
  limit?: number;
}

export const usersApi = {
  list(params: ListUsersParams = {}): Promise<UsersListResponse> {
    const query = buildQuery({
      page: params.page ?? 1,
      limit: params.limit ?? 25,
    });
    return apiRequest<UsersListResponse>(`/admin/users${query}`);
  },

  create(payload: CreateUserPayload): Promise<UserItem> {
    return apiRequest<UserItem>("/admin/users", "POST", payload);
  },

  update(userId: string, payload: UpdateUserPayload): Promise<UserItem> {
    return apiRequest<UserItem>(`/admin/users/${userId}`, "PUT", payload);
  },

  remove(userId: string): Promise<void> {
    return apiRequest<void>(`/admin/users/${userId}`, "DELETE");
  },

  cognitoGroups(): Promise<string[]> {
    return apiRequest<string[]>("/admin/cognito/groups");
  },
};
